import React from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';
import { Facebook, Twitter, LinkedIn, Telegram } from '@mui/icons-material';

const MUIFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#fa5d15',
        color: 'white',
        py: 4,
        mt: 5,
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 1 }}>
        <IconButton
          href="https://twitter.com/DerejaOfficial"
          target="_blank"
          sx={{ color: 'white' }}
        >
          <Twitter />
        </IconButton>
        <IconButton
          href="https://web.facebook.com/DerejaJobs"
          target="_blank"
          sx={{ color: 'white' }}
        >
          <Facebook />
        </IconButton>
        <IconButton
          href="https://et.linkedin.com/company/dereja.com"
          target="_blank"
          sx={{ color: 'white' }}
        >
          <LinkedIn />
        </IconButton>
        <IconButton
          href="https://t.me/Derejaofficial"
          target="_blank"
          sx={{ color: 'white' }}
        >
          <Telegram />
        </IconButton>
      </Box>

      <Typography variant="body2" sx={{ mb: 1 }}>
        © 2025 Dereja. All rights reserved.
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Link href="https://dereja.com/privacy-policy" underline="hover" color="inherit">
          Privacy Policy
        </Link>
        
      </Box>
    </Box>
  );
};

export default MUIFooter;
